import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { TermsAndConditionsKey } from '@thehubz/shared/model';

@Component({
  selector: 'sp-terms-conditions-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './terms-conditions-dialog.component.html',
  styleUrls: ['./terms-conditions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsConditionsDialogComponent implements OnInit {
  readonly CustomClients = CustomClients;
  content?: string;

  constructor(
    public matDialogRef: MatDialogRef<TermsConditionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TermsConditionsDialogConfig,
    @Inject(ENVIRONMENT) protected readonly env: ClientEnvironment,
  ) {}

  ngOnInit(): void {
    if (!this.data) {
      throw new Error('Config is required for terms and conditions popup');
    }

    this.content = this.env.termsConditionsPopup?.content[this.data.featureKey];

    this.matDialogRef.updateSize('100%');
  }

  onAcceptClick() {
    this.matDialogRef.close({
      accepted: true,
    });
  }

  onCancelClick() {
    this.matDialogRef.close({
      accepted: false,
    });
  }
}

export interface TermsConditionsDialogConfig {
  featureKey: TermsAndConditionsKey;
}
